export default __webpack_public_path__ + "static/media/rating24.a69df9d5.svg";